import React from "react";

import Page from "../components/Page";

import ScheduleOfEmployee from "../components/ScheduleOfEmployee";
import CompanySchedule from "../components/CompanySchedule";

import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";

let credentials = JSON.parse(localStorage.getItem("credentials"));

const SchedulePage = () => (
  <Page title="Rooster">
    <CenteredPageContentContainer>
      <PaperContainer title="Rooster">
        {(() => {
          switch (credentials.user.type) {
            case "PERSON":
              return <CompanySchedule />;
            case "EMPLOYEE":
              return (
                <ScheduleOfEmployee employeeEmail={credentials.user.email} />
              );
            default:
              null;
          }
        })()}
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default SchedulePage;



// WEBPACK FOOTER //
// ./src/pages/SchedulePage.js